import { createStore, compose, combineReducers, applyMiddleware, StoreEnhancerStoreCreator } from "redux";
import thunkMiddleware from "redux-thunk";
import { History } from "history";

import { RootState } from "./state";
import ReducerRegistry from "./lib/ReducerRegistry";
import routerMiddleware from "./common/middlewares/routerMiddleware";
import visitApiMiddleware from "./common/middlewares/visitApiMiddleware";
import { createDynamicMiddleware } from "./common/middlewares/dynamicMiddleware";

export default function configureStore({
  history,
  reducerRegistry,
}: {
  history: History;
  reducerRegistry: ReducerRegistry;
}) {
  // NOTE(miyashiro): For devtools
  const composeEnhancers: typeof compose =
    process.env.NODE_ENV === "development" &&
    typeof window === "object" &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          shouldHotReload: true, // Set true to improve HMR but never forget to turn off before release.
        })
      : compose;

  const dynamicMiddleware = createDynamicMiddleware(reducerRegistry);
  const store = createStore<RootState>(
    combineReducers(reducerRegistry.getReducers()),
    composeEnhancers<StoreEnhancerStoreCreator<RootState>>(
      applyMiddleware(thunkMiddleware, visitApiMiddleware, dynamicMiddleware, routerMiddleware(history))
    )
  );

  return store;
}



// WEBPACK FOOTER //
// ./frontend/src/configureStore.ts